<template>
    <div>
        <phoneNav/>
        <div class="aboutPhone">
            <div class="about-banner">
                <video
                        controls
                        autoplay
                        loop
                        poster="../../assets/images/phone/video-image.png"
                        webkit-playsinline="true"
                        playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        x-webkit-airplay="allow"
                        x5-video-orientation="portraint"
                        style="object-fit:fill"
                        type="video/mp4"
                        width="100%"
                        height="200"
                >
                    <source src="../../assets/images/web/about-banner.mp4" type="video/mp4">
                    <p>你的浏览器不支持 <code>video</code> 标签.</p>
                    <!-- <img src="../assets/images/web/about-banner.jpg" /> -->
                <!--<video id="video" width="100%" height="200" controls autoplay
                       src="../../assets/images/web/about-banner.mp4">-->
                    <!-- <source :src="bannerImage" type="video/mp4">
                    您的浏览器不支持 video 标签。 -->
                </video>
            </div>
            <div class="about-msg">
                <Row>
                    <Col span="24">
                        <div class="about-cont">
                            <ProjectContPhone :tit="projectTit" :msg="projectDec" :subheading="subHeading"/>
                        </div>
                    </Col>

                </Row>
            </div>

            <div class="about-box">
                <h3 class="about-tit">新闻中心</h3>
                <div class="new-center">
                    <Tabs :value='"c"+column.id' @on-click="clickColumn">
                        <TabPane :label="item.nodeName" :name='"c"+item.id' :key="item.id" v-for="item in columnList">
                            <NewsCardPhone :nodeId="column.id"></NewsCardPhone>
                        </TabPane>
                        <!-- <TabPane label="公司新闻" name="name2">
                            <NewsCard/>
                        </TabPane>
                        <TabPane label="领导关怀" name="name3">
                            <NewsCard/>
                        </TabPane> -->
                    </Tabs>
                    <div class="moreNews">
                        <!-- <a href="#/newsList">更多资讯</a> -->
                        <router-link :to="{name:'newsList',query:{nodeId:column.id}}">更多资讯</router-link>
                    </div>
                </div>
            </div>

            <div class="about-box-bg">
                <div class="about-box">
                    <h3 class="about-tit">发展历程</h3>
                    <DevelopPhone/>
                </div>
            </div>
            <div class="about-box">
                <h3 class="about-tit">管理团队</h3>
                <div class="team">
                    <Row>
                        <Col span="8" :key="item.id" v-for="item in teamList">
                            <div class="t-cont">
                                <div class="hdImg"><img :src="item.imageUrl" /></div>
                                <div class="name">{{item.author}}</div>
                                <div class="jobtitle">{{item.title}}</div>
                            </div>
                        </Col>

                        <!-- <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/teampic2.jpg" /></div>
                            <div class="name">蒋蕾</div>
                            <div class="jobtitle">盛大天地运营 副总裁</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/teampic3.jpg" /></div>
                            <div class="name">王珏</div>
                            <div class="jobtitle">盛大天地运营管理中心 总监</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/teampic1.jpg" /></div>
                            <div class="name">姓名</div>
                            <div class="jobtitle">职位</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/teampic1.jpg" /></div>
                            <div class="name">姓名</div>
                            <div class="jobtitle">职位</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/teampic1.jpg" /></div>
                            <div class="name">徐超</div>
                            <div class="jobtitle">盛大天地运营总裁</div>
                        </div>
                        </Col> -->
                    </Row>
                </div>
            </div>
            <div class="about-box">
                <h3 class="about-tit">荣誉资质</h3>
                <div class="team zizhi">
                    <Row>
                        <Col span="8" :key="item.id" v-for="item in ziZhiList">
                            <div class="t-cont">
                                <div class="hdImg"><img :src="item.imageUrl" /></div>
                                <div class="zztitle">{{item.title}}</div>
                            </div>
                        </Col>

                        <!-- <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/zzPic2.jpg" /></div>
                            <div class="zztitle">上海市创业孵化示范基地</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/zzPic3.jpg" /></div>
                            <div class="zztitle">上海市科技创新创业载体</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/zzPic4.jpg" /></div>
                            <div class="zztitle">上海市文化创意产业园区</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/zzPic5.jpg" /></div>
                            <div class="zztitle">上海大学产学研基地</div>
                        </div>
                        </Col>
                        <Col span="4">
                        <div class="t-cont">
                            <div class="hdImg"><img src="../assets/images/web/zzPic6.jpg" /></div>
                            <div class="zztitle">复旦大学智慧城市实训基地</div>
                        </div>
                        </Col> -->
                    </Row>
                </div>
            </div>
        </div>
        <FooterPhone/>
    </div>

</template>

<script>
    import phoneNav from '@/components/phoneNav.vue';
    import NewsCardPhone from "@/components/NewsCardPhone";
    import ProjectContPhone from "@/components/ProjectContPhone";
    import DevelopPhone from "@/components/DevelopPhone";
    import FooterPhone from "../../components/FooterPhone";

    export default {
        name: 'about',
        components: {
            phoneNav,
            NewsCardPhone,
            ProjectContPhone,
            DevelopPhone,
            FooterPhone
        },
        data() {
            return {
                projectTit: '盛大天地运营',
                subHeading: '引领中国科创园区运营服务新模式',
                projectDec: '      盛大天地（中国）有限公司引领中国科创园区运营服务新模式，12年来专业从事科创园区规划定位、翻改建、招商物管、运营管理的全程服务，在上海、硅谷等地在管的优质资产已达10个项目，总建筑面积约80万平方。通过打造以“全生命周期科创生态系统”为核心的科创园区资产服务全面解决方案，实现了业主、资管方、园区企业及员工的发展共赢。',
                columnList: [],
                loading: false,
                columnId: 0,
                nodeName: '',
                column: {},
                teamList: [],
                ziZhiList: [],
                bannerImage: ''
            }
        },
        methods: {
            getColumns() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetNodesByName?name=运管新闻")
                    .then(res => {
                        this.columnList = res.data.result;
                        console.log(this.columnList);
                        if (this.columnList.length > 0) {
                            this.$nextTick(() => {
                                this.column = this.columnList[0];
                            })
                            console.log(this.column);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getTeamList() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetContentsByNodeName?nodeName=管理团队")
                    .then(res => {
                        this.teamList = res.data.result;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getZiZhiList() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetContentsByNodeName?nodeName=荣誉资质")
                    .then(res => {
                        this.ziZhiList = res.data.result;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getBannerImage() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetContentsByNodeName?nodeName=关于我们banner")
                    .then(res => {
                        if(res.data.result.length>0){
                            console.log(res.data.result);
                            this.bannerImage = res.data.result[0].imageUrl;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            clickColumn(result){
                console.log(result);
                let id=result.substring(1);
                console.log(id);
                this.columnList.forEach(item => {
                    if(item.id==id){
                        this.column=JSON.parse(JSON.stringify(item));
                    }
                });
            },
        },
        mounted() {
            this.getColumns();
            this.getBannerImage();
            this.getTeamList();
            this.getZiZhiList();
        }
    }
</script>

<style lang="less">
    .aboutPhone {
        background-color:#fff;
        width: 100%;
        box-sizing: border-box;
        overflow-y: scroll;
        height: 100vh;
        .about-banner {
            width: 100%;
            margin-top: 46px;

            video {
                object-fit: cover;
                border-radius: 5px;
            }
        }

        .about-msg {
            .about-cont {
                .project-cont-phone {
                    padding: 20px 40px;
                    text-align: center;

                    h2 {
                        padding-bottom: 5px;
                        color: #2A3341;
                    }

                    h4 {
                        color: #2A3341;
                    }
                }
            }
        }
        .about-box {
            margin-top: 30px;

            .about-tit {
                margin-bottom: 20px;
                font-size: 32px;
                color: #999;
                text-align: center;
            }

            .new-center {
                position: relative;
                padding:20px;
                .ivu-tabs-bar {
                    border-width: 0;
                }

                .ivu-tabs-nav {
                    font-size: 14px;
                    color: #333;

                    .ivu-tabs-tab {
                        padding-bottom: 13px;
                        /*margin-right:0;*/
                        padding-left:10px;
                        padding-right:10px;
                    }
                }

                .ivu-tabs-tab-active {
                    color: #333;
                }

                .ivu-tabs-ink-bar {
                    background-color: #3376FE;
                }

                .moreNews {
                    font-size: 16px;
                    color: #3376FE;
                    text-align: center;
                    padding:20px;
                }
            }

            .team {
                padding:15px;

                .ivu-row {
                    margin: 0 -10px;

                    .ivu-col {
                        text-align: center;

                        .t-cont {
                            margin: 0 10px;
                            border: 1px solid #E3E3E3;
                            box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.5);
                            border-radius: 5px;

                            .hdImg {
                                height: 110px;
                                background-color: #CFCFCF;
                                border-radius: 5px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 5px;
                                    overflow: hidden;
                                }

                            }

                            .name {
                                font-size: 16px;
                                color: #666;
                                padding: 10px 0 5px 0;
                            }

                            .jobtitle {
                                padding-bottom: 8px;
                                font-size: 12px;
                                color: #999;
                                height: 36px;
                            }
                        }

                        .t-cont:hover {
                            box-shadow: 0px 5px 10px 0px rgba(18, 59, 89, 0.19);
                        }
                    }
                }
            }

            .zizhi {
                .ivu-row {

                    .ivu-col {

                        .t-cont {
                            margin-bottom:15px;
                            .hdImg {
                                height: 75px;

                                img {
                                    height: 100%;
                                }
                            }

                            .zztitle {
                                font-size: 12px;
                                color: #666;
                                padding: 5px 0;
                                height:44px;
                            }
                        }
                    }
                }
            }
        }
        .about-box-bg {
            background: linear-gradient(148deg, #EEEFF6, #F8F9FE);
            padding-top: 1px;
            padding-bottom: 40px;
            /*padding:40px 0;*/


        }
    }
</style>